// index.ts
import { HardRef, WeakRef } from "./refs.mjs";
var AbstractEvents = class {
  /** All our configured listeners, as arrays keyed by event name */
  _listeners = {};
  /** Register a new event listener */
  _add(name, listener, once, weak) {
    if (typeof listener !== "function") throw new TypeError("Listener must be a function");
    let listeners = this._listeners[name];
    if (!listeners) listeners = this._listeners[name] = [];
    for (let i = 0; i < listeners.length; i++) {
      const current = listeners[i];
      const [reference] = current;
      const referenced = reference.deref();
      if (referenced === void 0) {
        listeners.splice(i--);
      } else if (referenced === listener) {
        current[1] = once;
        return this;
      }
    }
    const ref = weak ? new WeakRef(listener) : new HardRef(listener);
    listeners.push([ref, once]);
    return this;
  }
  /* ------------------------------------------------------------------------ */
  $emit(name, event) {
    const listeners = this._listeners[name];
    if (!listeners) return false;
    let called = false;
    for (let i = 0; i < listeners.length; i++) {
      const [reference, once] = listeners[i];
      const listener = reference.deref();
      if (listener === void 0) {
        listeners.splice(i--, 1);
        continue;
      }
      try {
        listener.call(this, event);
        called = true;
      } catch (error) {
        console.error("Error in listener", error);
      } finally {
        if (once) listeners.splice(i--, 1);
      }
    }
    return called;
  }
  /* ------------------------------------------------------------------------ */
  on(name, listener, weak = false) {
    return this._add(name, listener, false, weak);
  }
  once(name, listener, weak = false) {
    return this._add(name, listener, true, weak);
  }
  off(name, listener) {
    const listeners = this._listeners[name];
    if (!listeners) return this;
    if (listeners.length === 0) return this;
    for (let i = 0; i < listeners.length; i++) {
      const [reference] = listeners[i];
      const referenced = reference.deref();
      if (referenced === void 0 || listener === referenced) {
        listeners.splice(i--, 1);
      }
    }
    return this;
  }
};
export {
  AbstractEvents
};
//# sourceMappingURL=index.mjs.map
